import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppSettings } from 'src/app/core/common/app-settings';
import { PublicadoVo } from 'src/app/shared/models/caso/publicado-vo.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'vex-publicado-view',
  templateUrl: './publicado-view.component.html',
  styleUrls: ['./publicado-view.component.scss']
})
export class PublicadoViewComponent implements OnInit {

  appSettings = AppSettings;
  vo: PublicadoVo;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.vo = data.entity;
  }

  ngOnInit(): void {

  }

  foto(): string {
    return environment.apiSecurityUrl + 'api/v1/publicados/' + this.vo.desaparecido + '/afiche?' + (new Date()).getTime();
  }
}
